import Head from 'next/head';
import { useRouter } from 'next/router';
import { createGlobalStyle } from 'styled-components';
import '@spotify-internal/encore-web/css/encore-creator-dark-theme.css';
import '@spotify-internal/encore-web/css/fonts.css';
import '@spotify-internal/encore-web/css/encore-small-devices-layout-theme.css';
import '@spotify-internal/encore-web/css/encore-medium-devices-layout-theme.css';
import '@spotify-internal/encore-web/css/encore-component-styles.css';
import '@spotify-internal/encore-web/css/encore-creator-light-theme.css';

const GlobalStyles = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  html,
  body,
  #__next {
    height: 100%;
    margin: 0;
    padding: 0;
  }
`;

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const currentPath = useRouter().pathname;
  const pagesWithDarkTheme = ['/', '/unauthorized', '/noassociation'];
  const showDarkTheme = pagesWithDarkTheme.includes(currentPath);

  return (
    <>
      <GlobalStyles />
      <Head>
        <link rel="shortcut icon" href="/favicon.ico?v=1" />
        <title>Catalog</title>
      </Head>
      <div
        className={
          showDarkTheme
            ? 'encore-creator-dark-theme'
            : 'encore-creator-light-theme'
        }
      >
        {children}
      </div>
    </>
  );
};
